
import { PhaseOne } from "./PhaseOne";
import { PhaseTwo } from "./PhaseTwo";
import { PhaseThree } from "./PhaseThree";

export const HowItWorksContainer = () => {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            How <span className="text-gradient">Wamy</span> Works
          </h2>
          <p className="text-lg text-gray-600">
            Our AI-powered platform works in three seamless phases to transform the 
            property litigation underwriting process from start to finish.
          </p>
        </div>

        <div className="relative">
          {/* Connection line */}
          <div className="absolute top-24 left-1/2 transform -translate-x-1/2 w-1 h-[calc(100%-120px)] bg-gradient-to-b from-wamy-500 to-teal-500 hidden md:block"></div>
          
          <div className="space-y-24">
            <PhaseOne />
            <PhaseTwo />
            <PhaseThree />
          </div>
        </div>
      </div>
    </section>
  );
};
